(() => {
  if (window.__waveEditorialLoaded) return;
  window.__waveEditorialLoaded = true;
  document.documentElement.classList.add('wave-motion-ready');

  const selectors = [
    '[data-wave-reveal]',
    '.wave-collection-hero__content',
    '.wave-editorial-intro__copy',
    '.wave-color-product__copy',
    '.wave-split-feature__copy',
    '.wave-final-cta__content',
    '.wave-product-grid__card'
  ];

  const initReveal = () => {
    const items = document.querySelectorAll(selectors.join(','));
    if (!('IntersectionObserver' in window)) {
      items.forEach(el => el.classList.add('wave-is-visible'));
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('wave-is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
    items.forEach((el, index) => {
      el.style.transitionDelay = `${Math.min(index % 4, 3) * 70}ms`;
      observer.observe(el);
    });
  };

  const initParallax = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const images = document.querySelectorAll('[data-wave-parallax]');
    let ticking = false;
    const update = () => {
      images.forEach(img => {
        const rect = img.getBoundingClientRect();
        const center = rect.top + rect.height / 2;
        const offset = (center - window.innerHeight / 2) / window.innerHeight;
        img.style.transform = `translate3d(0, ${offset * -28}px, 0) scale(1.06)`;
      });
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
  };

  const init = () => { initReveal(); initParallax(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
